const toUTCTime = (dateTimeString) => {
  let date = new Date(dateTimeString)
  let utc = Math.floor(Math.abs(date.getTimezoneOffset() / 60))
  let utcDecimal = Math.abs(date.getTimezoneOffset()) - utc * 60
  return `${date.toLocaleString()} (UTC+${utc}${utcDecimal !== 0 ? ':' + utcDecimal : ''})`
}

export default toUTCTime
